import { useState } from "react";
import { TypeBody1, TypeH2 } from "../../atoms/fonts/Types";
import { StandarButton } from "../../atoms/util/buttons/Buttons";
import { IconArrowRight, IconLinkedIn, IconMail, IconPhone, IconPin } from "../../atoms/icons/Icons";
import { useT } from "../../../i18n/LanguageContext";
import "./SectionFiveContent.css";

const PHONE = "+1 (814) 441-6131";
const EMAIL = "management@nearshoredesign.co";
const WHATSAPP_URL = "https://wa.link/ou2cni";
const LINKEDIN_URL = "https://www.linkedin.com/company/near-shore-design-co/";

// Visitors pick services and add a line; "Send by email" opens their mail
// app with the inquiry already written.
export function SectionFiveContent() {
	const { t } = useT();
	const services = t("services.items");
	const [picked, setPicked] = useState([]);
	const [message, setMessage] = useState("");

	const toggle = (key) =>
		setPicked((prev) => (prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]));

	const pickedTitles = Array.isArray(services)
		? services.filter((s) => picked.includes(s.key)).map((s) => s.title)
		: [];
	const body = [
		t("contact.emailIntro"),
		...pickedTitles.map((title) => `- ${title}`),
		"",
		message,
	]
		.join("\n")
		.trim();
	const mailto = `mailto:${EMAIL}?subject=${encodeURIComponent(t("contact.emailSubject"))}&body=${encodeURIComponent(body)}`;

	return (
		<div className="contactContent">
			<div className="contactContent_intro">
				<span className="-eyebrow" data-reveal="rise">
					{t("contact.eyebrow")}
				</span>
				<TypeH2 className="contactContent_title">
					<span data-reveal="tide" style={{ "--d": 1 }}>
						{t("contact.title")}
					</span>
				</TypeH2>
				<div data-reveal="rise" style={{ "--d": 3 }}>
					<TypeBody1 className="contactContent_body">{t("contact.body")}</TypeBody1>
				</div>

				<ul className="contactContent_info" data-reveal="rise" style={{ "--d": 4 }}>
					<li>
						<a href={`tel:${PHONE.replace(/[^\d+]/g, "")}`}>
							<IconPhone />
							<span>{PHONE}</span>
						</a>
					</li>
					<li>
						<a href={`mailto:${EMAIL}`}>
							<IconMail />
							<span>{EMAIL}</span>
						</a>
					</li>
					<li>
						<span>
							<IconPin />
							<span>{t("contact.info.location")}</span>
						</span>
					</li>
				</ul>
			</div>

			<form
				className="inquiry"
				data-reveal="rise"
				style={{ "--d": 2 }}
				onSubmit={(e) => {
					e.preventDefault();
					window.location.href = mailto;
				}}
			>
				<fieldset className="inquiry_group">
					<legend className="inquiry_label">{t("contact.pickLabel")}</legend>
					<div className="inquiry_chips">
						{Array.isArray(services) &&
							services.map((s) => {
								const on = picked.includes(s.key);
								return (
									<button
										key={s.key}
										type="button"
										className={`inquiry_chip ${on ? "is-on" : ""}`}
										aria-pressed={on}
										onClick={() => toggle(s.key)}
									>
										<span className="inquiry_tick" aria-hidden="true" />
										{s.title}
									</button>
								);
							})}
					</div>
				</fieldset>

				<label className="inquiry_group">
					<span className="inquiry_label">{t("contact.messageLabel")}</span>
					<textarea
						className="inquiry_text"
						rows={4}
						value={message}
						placeholder={t("contact.messagePlaceholder")}
						onChange={(e) => setMessage(e.target.value)}
					/>
				</label>

				<div className="inquiry_actions">
					<StandarButton variant={1} type="submit" label={t("contact.sendEmail")} icon={<IconArrowRight />} />
					<StandarButton
						variant={3}
						label={t("contact.whatsapp")}
						href={WHATSAPP_URL}
						target="_blank"
						rel="noreferrer noopener"
					/>
					<a
						className="inquiry_social"
						href={LINKEDIN_URL}
						target="_blank"
						rel="noreferrer noopener"
						aria-label={t("contact.linkedin")}
					>
						<IconLinkedIn />
					</a>
				</div>
			</form>
		</div>
	);
}
